import styled from 'styled-components';
import { fontSettings } from '@lerna-core';

export const CourseSkillsContainerStyled = styled.div`
  color: ${({ theme }): string => theme.COLOR.TEXT_DARK_COLOR};
  ${({ theme }): string => fontSettings(theme.FONT.SIZE_17, theme.FONT)}
`;
